import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import { Switch } from "../components/ui/switch";
import { toast } from "sonner";
import { Megaphone, Loader2 } from "lucide-react";

export const SponsorEditor = () => {
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/sponsor").then(({ data }) => setForm(data)).catch(() => {});
  }, []);

  if (!form) return null;
  const set = (k) => (v) => setForm({ ...form, [k]: v });
  const inputCls = "mt-1 border-[#1E293F] bg-[#141B2D] text-white placeholder:text-[#64748B]";

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/sponsor", form);
      toast.success("Sponsored banner updated.");
    } catch { toast.error("Could not save banner."); }
    finally { setSaving(false); }
  };

  return (
    <div className="animate-fade-up mb-8 rounded-2xl border border-[#FFB800]/30 bg-[#0F1424] p-6" data-testid="sponsor-editor">
      <div className="flex items-center justify-between">
        <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-white"><Megaphone size={18} className="text-[#FFB800]" /> Sponsored Banner</h2>
        <div className="flex items-center gap-2">
          <span className="text-sm text-[#94A3B8]">{form.enabled ? "Live" : "Hidden"}</span>
          <Switch data-testid="sponsor-enabled" checked={form.enabled} onCheckedChange={set("enabled")} />
        </div>
      </div>
      <p className="mt-1 text-sm text-[#94A3B8]">Shows on the Wall of Shame and Stats pages. Sell this slot to 2K creators or tournaments.</p>

      <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
        <div><Label className="text-[#CBD5E1]">Title</Label><Input data-testid="sponsor-title" value={form.title} onChange={(e) => set("title")(e.target.value)} className={inputCls} placeholder="Sponsor name / headline" /></div>
        <div><Label className="text-[#CBD5E1]">Button text</Label><Input data-testid="sponsor-cta" value={form.cta} onChange={(e) => set("cta")(e.target.value)} className={inputCls} placeholder="Learn More" /></div>
        <div className="sm:col-span-2"><Label className="text-[#CBD5E1]">Subtitle</Label><Input data-testid="sponsor-subtitle" value={form.subtitle} onChange={(e) => set("subtitle")(e.target.value)} className={inputCls} placeholder="Short tagline" /></div>
        <div><Label className="text-[#CBD5E1]">Link (URL or /path)</Label><Input data-testid="sponsor-link" value={form.link} onChange={(e) => set("link")(e.target.value)} className={inputCls} placeholder="https://... or /supporter" /></div>
        <div><Label className="text-[#CBD5E1]">Logo image URL</Label><Input data-testid="sponsor-image" value={form.image_url} onChange={(e) => set("image_url")(e.target.value)} className={inputCls} placeholder="https://... (optional)" /></div>
      </div>
      <Button data-testid="sponsor-save" onClick={save} disabled={saving} className="mt-4 bg-[#FFB800] font-bold text-[#090C15] hover:bg-[#FFB800]/90">
        {saving && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Save Banner
      </Button>
    </div>
  );
};
